import { logosDataAt } from '../data/logos-data-at';
import { logosDataDe } from '../data/logos-data-de';
function marketingLogoNames(country) {
    switch (country) {
        case 'ch':
        case 'de':
            return [
                'Bild',
                'Frankfurter Allgemeine Zeitung',
                'GQ Magazine',
                'Business Insider',
                'Human Resources Manager',
                'Spotify',
                'Galileo'
            ];
        case 'at':
        default:
            return [
                'ORF',
                'Hitradio Ö3',
                'ProSieben Austria',
                'kronehit',
                'Servus TV',
                'FM4',
                'Puls 4',
                'ATV'
            ];
    }
}
function bannerMarketingLogoNames(country) {
    switch (country) {
        case 'ch':
        case 'de':
            return ['Bild', 'Sat.1'];
        case 'at':
        default:
            return ['Hitradio Ö3', 'ORF (Österreichischer Rundfunk)'];
    }
}
function footerPartnerLogoNames(country) {
    switch (country) {
        case 'ch':
        case 'de':
            return [
                'stellenanzeigen.de GmbH',
                'yourfirm GmbH',
                'Austrian Research Promotion Agency',
                'Ernst & Young',
                'PwC Österreich'
            ];
        case 'at':
        default:
            return [
                'karriere.at',
                'Austrian Research Promotion Agency',
                'PwC Österreich',
                'Ernst & Young'
            ];
    }
}
function bannerCustomerLogoNames(country) {
    switch (country) {
        case 'at':
        case 'ch':
        case 'de':
        default:
            return ['Baumit GmbH', 'Manpower'];
    }
}
function posterCustomerLogoNames(country) {
    switch (country) {
        case 'at':
        case 'ch':
        case 'de':
        default:
            return ['Burger King', 'Nespresso'];
    }
}
function expertsMarketingLogoNames(country) {
    switch (country) {
        case 'at':
        case 'ch':
        case 'de':
        default:
            return ['Facebook', 'Instagram', 'Puls 4', 'kronehit', 'Google'];
    }
}
function useCaseNetworkLogoNames(country) {
    switch (country) {
        case 'at':
            return ['Indeed', 'jobs.at', 'neuvoo/talent.com', 'newJOB', 'alleskralle'];
        case 'ch':
        case 'de':
        default:
            return ['neuvoo/talent.com', 'Jooble', 'Stellenonline', 'jobgate', 'Jobrapido'];
    }
}
export const getMarketingLogos = (country, purpose) => {
    const logos = country === 'de' ? logosDataDe.marketing : logosDataAt.marketing;
    let names;
    switch (purpose) {
        case 'brandBanner':
            names = bannerMarketingLogoNames(country);
            break;
        case 'experts':
            names = expertsMarketingLogoNames(country);
            break;
        default:
            names = marketingLogoNames(country);
            break;
    }
    return logos.filter(logo => names.includes(logo.imgAlt));
};
export const getPartnerLogos = (country, purpose) => {
    const logos = logosDataAt.partner;
    let names;
    switch (purpose) {
        case 'footer':
        default:
            names = footerPartnerLogoNames(country);
            break;
    }
    return logos.filter(logo => names.includes(logo.imgAlt));
};
export const getCustomerLogos = (country, purpose) => {
    const logos = country && country === 'de' ? logosDataDe.customer : logosDataAt.customer;
    let names;
    switch (purpose) {
        case 'brandBanner':
            names = bannerCustomerLogoNames(country);
            break;
        case 'poster':
            names = posterCustomerLogoNames(country);
            break;
        default:
            return logos;
    }
    return logos.filter(logo => names.includes(logo.imgAlt));
};
export const getNetworkLogos = (country, purpose) => {
    const logos = logosDataAt.network;
    let names;
    switch (purpose) {
        case 'useCase':
            names = useCaseNetworkLogoNames(country);
            break;
        case 'imprint':
        default:
            return logos;
    }
    return logos.filter(logo => names.includes(logo.imgAlt));
};
export const getPaymentLogos = (purpose) => {
    switch (purpose) {
        case 'pricing':
            return logosDataAt.payment.filter(logo => logo.imgAlt !== 'Per Rechnung');
        default:
            return logosDataAt.payment;
    }
};
//# sourceMappingURL=logos.js.map